// src/hooks/useLogout.ts

export const useLogout = () => {
  return () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth');
    window.location.href = '/login';
  };
};
